const zhCN = {
  backBtn: '返回',
  submitBtn: '提交',

  vivoDetectionTitle: '活体检测',

  enableVivoDetection: '是否启用活体检测功能',
  option_true: '是',
  option_false: '否',

  faceDetectionTitle: '人脸检测',

  faceRecognitionAngle: '人脸识别角度',
  faceRecognitionDistance: '人脸识别距离',
  faceRecognitionThreshold: '人脸识别阈值',
  citizenFaceRecognitionThreshold: '芯片照和现场照人脸识别阈值',

  reminderTime: '人脸识别失败提醒时间',
  reminderTimeTxt: '请输入人脸识别失败提醒时间',
  reminderTimeUnit: '秒',  
  reminderTimeBlank: '请输入人脸识别失败提醒时间！',
  reminderTimeWarning: '请输入正整数！',
  reminderTimeMax: '人脸识别失败提醒时间最大值不超过10秒！',
  reminderTimeMin: '人脸识别失败提醒时间最小值不低于1秒！',

  maskDetectionTitle: '口罩检测',

  enableMaskDetection: '是否启用口罩检测功能',
  closedWhenNoMask: '未检测到口罩不打开门禁',

  temperatureDetectionTitle: '体温检测',

  enableTemperatureDetection: '是否启用体温检测功能',
  closedWhenAbnormothermia: '体温异常不打开门禁',

  temperatureAnomaly: '体温异常值',
  temperatureAnomalyTxt: '请输入体温异常值',
  temperatureAnomalyBlank: '请输入体温异常值！',
  temperatureAnomalyWarning: '请输入整数或带一位小数的数字！',
  temperatureAnomalyMax: '体温异常值最大值不超过100℃！',
  temperatureAnomalyMin: '体温异常值最小值不低于0℃！',

  showThermalImagery: '是否显示热成像',

  recogRecordTitle: '识别记录',

  saveRecogRecord: '是否保存识别记录',
  autoSyncRecordedToServer: '是否自动同步识别记录到服务器',
  saveSitePhotos: '是否保存识别现场照',
  autoSyncSitePhotosToServer: '是否自动同步现场照到服务器',
  deleteDataAfterAutoSync: '同步成功后是否自动删除已同步数据'
}
const enUS = {
  backBtn: 'Back',
  submitBtn: 'Submit',

  vivoDetectionTitle: 'Vivo Detection',

  enableVivoDetection: 'Enable Vivo Detection',
  option_true: 'True',
  option_false: 'False',

  faceDetectionTitle: 'Face Detection',

  faceRecognitionAngle: 'AFR Angle',
  faceRecognitionDistance: 'AFR Distance',
  faceRecognitionThreshold: 'AFR Threshold',
  citizenFaceRecognitionThreshold: 'AFR Threshold for ID & scene photos',

  reminderTime: 'AFR Failure Reminder Time',
  reminderTimeTxt: 'Enter face recognition failure reminder time',
  reminderTimeUnit: 'second',  
  reminderTimeBlank: 'This time can\'t be blank!',
  reminderTimeWarning: 'Please enter a positive integer!',
  reminderTimeMax: 'The maximum reminder time of face recognition failure should\'t exceed 10 seconds!',
  reminderTimeMin: 'The minimum reminder time of face recognition failure should\'t less than 1 second!',

  maskDetectionTitle: 'Mask Detection',

  enableMaskDetection: 'Enable Mask Detection',
  closedWhenNoMask: 'Closed When No-mask',

  temperatureDetectionTitle: 'Temperature Detection',

  enableTemperatureDetection: 'Enable Temperature Detection',
  closedWhenAbnormothermia: 'Closed When Temperature Anomaly',

  temperatureAnomaly: 'Temperature Anomaly',
  temperatureAnomalyTxt: 'Enter temperature anomaly value',
  temperatureAnomalyBlank: 'This value can\'t be blank!',
  temperatureAnomalyWarning: 'Please enter an integer or a number with a decimal point!',
  temperatureAnomalyMax: 'The maximum temperature abnormality value does not exceed 100℃!',
  temperatureAnomalyMin: 'The minimum abnormal temperature value should not be lower than 0℃!',

  showThermalImagery: 'Show Thermal Imagery',

  recogRecordTitle: 'Recognition Record',

  saveRecogRecord: 'Save Recognition Record',
  autoSyncRecordedToServer: 'Auto-Sync Recorded To Server',
  saveSitePhotos: 'Save Site Photos',
  autoSyncSitePhotosToServer: 'Auto-Sync Site Photos To Server',
  deleteDataAfterAutoSync: 'Delete Data After Auto-Sync'
}

export default { zhCN, enUS }